import { render, staticRenderFns } from "./TableRestore.vue?vue&type=template&id=11542248"
import script from "./TableRestore.vue?vue&type=script&lang=js"
export * from "./TableRestore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports